import { Helmet } from "react-helmet";
import {
    Box,
    MenuItem,
    Divider,
    InputAdornment,
    TextField,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    FormControlLabel,
    Stack,
    Popper,
    ClickAwayListener,
    Grow,
    MenuList,
    FormGroup,
    Checkbox,
    Paper
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo } from "react";
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as ViewResult } from "../../../../assets/icons/viewResult.svg";
import { ReactComponent as JourneySummary } from "../../../../assets/icons/journeySummary.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import * as Util from "../../../../services/global.service";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useDispatch } from "react-redux";
import launchFormService from "../../../../services/launchForm.service";
import DialogLaunchForm from "./DialogLaunchForm";
import DialogViewResult from "./ViewResult";
import StopButton from "../../../../components/schedule/StopButton";

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const useStyles = makeStyles({
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    toggleBtnRoot: {
        background: `transparent !important`,
        color: "#6B6B6B !important",
        width: "320px",
        border: "none !important",
    },
    toggleBtnSelected: {
        background: `${cssVariables.color.primary}!important`,
        color: "#fff!important",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        "border-radius": "10px !important        "
    },
    tab: {
        fontSize: "16px !important",
        fontWeight: "300 !important",
        // color: "#A3A3A3 !important",
        '&.Mui-selected': {
            color: cssVariables.color.primary + " !important"
        }
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap'
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const History = () => {
    const [itemsProgress, setItemsProgress] = React.useState([]);
    const [mainItemsProgress, setMainItemsProgress] = React.useState([]);
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [searchProgress, setSearchValueProgress] = React.useState("");
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [openLaunchForm, setOpenLaunchForm] = React.useState(false);
    const [openViewResult, setOpenViewResult] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectLaunchForm, setSelectLaunchForm] = React.useState("");
    const [selectViewResult, setSelectViewResult] = React.useState("");
    const [success, setSuccess] = React.useState(true);
    const [fail, setFail] = React.useState(true);
    const [pending, setPending] = React.useState(true);

    useEffect(() => {
        getListData()
    }, []);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const EditNotActive = (data) => {
        if (data === "success") {
            setSuccess(!success)
        } else if (data === "fail") {
            setFail(!fail)
        } else if (data === "pending") {
            setPending(!pending)
        } else if (data === "selectAll") {
            if (success === true && fail === true && pending === true) {
                setSuccess(false)
                setFail(false)
                setPending(false)
            } else {
                setSuccess(true)
                setFail(true)
                setPending(true)
            }
        }
    };
    const filterActiveSerach = (data) => {
        let result = []
        let dataFilter = JSON.parse(JSON.stringify(data))
        if (success === false && fail === false && pending === false) {
            setItemsProgress(result)
        } else if (success === true && fail === true && pending === true) {
            setItemsProgress(data)
        } else {
            if (success === true && fail === false && pending === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "finish" || rs?.status === "pending");
                result = resultData
            } else if (success === true && fail === true && pending === false) {
                let resultData = dataFilter.filter(rs => rs?.status === "finish" || rs?.status === "fail");
                result = resultData
            } else if (success === false && fail === true && pending === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "fail" || rs?.status === "pending");
                result = resultData
            } else if (success === true && fail === false && pending === false) {
                let resultData = dataFilter.filter(rs => rs?.status === "finish");
                result = resultData
            } else if (success === false && fail === true && pending === false) {
                let resultData = dataFilter.filter(rs => rs?.status === "fail");
                result = resultData
            } else if (success === false && fail === false && pending === true) {
                let resultData = dataFilter.filter(rs => rs?.status === "pending");
                result = resultData
            }
            setItemsProgress(result)
        }
    };

    useEffect(() => {
        dataSerachsProgress()
    }, [success, fail, pending]);
    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    let openLaunch = (data) => {
        setOpenLaunchForm(true)
        setSelectLaunchForm(data)
    }

    let closeLaunchForm = () => {
        setOpenLaunchForm(false)
    }

    let openView = (data) => {
        setOpenViewResult(true)
        setSelectViewResult(data)
    }

    let closeViewResult = () => {
        setOpenViewResult(false)
    }

    const getListData = () => {
        launchFormService.getHistory().then(resp => {
            dataSerachsProgress(Util.formatData(resp?.data?.logs, []))
            setMainItemsProgress(Util.formatData(resp?.data?.logs, []))
        })
    }
    const handleSearchProgress = (event) => {
        setSearchValueProgress(event.target.value);
    };

    const currentData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * perPage;
        const lastPageIndex = firstPageIndex + perPage;
        return itemsProgress
            .slice(firstPageIndex, lastPageIndex);
    }, [itemsProgress, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = itemsProgress
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [itemsProgress, perPage]);

    useEffect(() => {
        let update = checkResired
        if (Object.keys(checkResired)[0] !== undefined) {
            if (update[Object.keys(checkResired)[0]] === false) {
                currentData.sort(function (b, a) {
                    if (Object.keys(checkResired)[0] === "code" || Object.keys(checkResired)[0] === "name") {
                        if (a.journey[Object.keys(checkResired)[0]] > b.journey[Object.keys(checkResired)[0]]) {
                            return -1;
                        }
                        if (b.journey[Object.keys(checkResired)[0]] > a.journey[Object.keys(checkResired)[0]]) {
                            return 1;
                        }
                        return 0;
                    } else if (Object.keys(checkResired)[0] === "created") {
                        if (a[Object.keys(checkResired)[0]].firstname + a[Object.keys(checkResired)[0]].lastname > b[Object.keys(checkResired)[0]].firstname + b[Object.keys(checkResired)[0]].lastname) {
                            return -1;
                        }
                        if (b[Object.keys(checkResired)[0]].firstname + b[Object.keys(checkResired)[0]].lastname > a[Object.keys(checkResired)[0]].firstname + a[Object.keys(checkResired)[0]].lastname) {
                            return 1;
                        }
                        return 0;
                    } else {
                        if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                            return -1;
                        }
                        if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                            return 1;
                        }
                        return 0;
                    }
                });
                setreSet(!reSet)
            } else if (update[Object.keys(checkResired)[0]] === true) {
                currentData.sort(function (a, b) {
                    if (Object.keys(checkResired)[0] === "code" || Object.keys(checkResired)[0] === "name") {
                        if (a.journey[Object.keys(checkResired)[0]] > b.journey[Object.keys(checkResired)[0]]) {
                            return -1;
                        }
                        if (b.journey[Object.keys(checkResired)[0]] > a.journey[Object.keys(checkResired)[0]]) {
                            return 1;
                        }
                        return 0;
                    } else if (Object.keys(checkResired)[0] === "created") {
                        if (a[Object.keys(checkResired)[0]].firstname + a[Object.keys(checkResired)[0]].lastname > b[Object.keys(checkResired)[0]].firstname + b[Object.keys(checkResired)[0]].lastname) {
                            return -1;
                        }
                        if (b[Object.keys(checkResired)[0]].firstname + b[Object.keys(checkResired)[0]].lastname > a[Object.keys(checkResired)[0]].firstname + a[Object.keys(checkResired)[0]].lastname) {
                            return 1;
                        }
                        return 0;
                    } else {
                        if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
                            return -1;
                        }
                        if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
                            return 1;
                        }
                        return 0;
                    }
                });
                setreSet(!reSet)
            }
        }
    }, [currentData]);

    useEffect(() => {
        dataSerachsProgress()
    }, [searchProgress]);
    useEffect(() => {
        dataSerachsProgress(mainItemsProgress)
    }, []);

    const dataSerachsProgress = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data !== undefined && data !== null ? data : mainItemsProgress))
        if (searchProgress !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    // if (key === 'name' || key === 'code') {
                    //     return rs[key].toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1;
                    // }
                    if (key === 'journey') {
                        let checkJourney = false;
                        if (rs[key].name !== undefined && rs[key].name.toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1) {
                            checkJourney = true;
                        }
                        if (rs[key].code !== undefined && rs[key].code.toString().toLowerCase().indexOf(searchProgress.toString().toLowerCase()) !== -1) {
                            checkJourney = true;
                        }
                        return checkJourney;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        await filterActiveSerach(result);
    };

    const clickLink = (data) => {
        navigate(data, { replace: false });
    }

    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
    };

    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            if (key === "created") {
                currentData.sort(function (b, a) {
                    if (a[key].firstname + a[key].lastname > b[key].firstname + b[key].lastname) {
                        return -1;
                    }
                    if (b[key].firstname + b[key].lastname > a[key].firstname + a[key].lastname) {
                        return 1;
                    }
                    return 0;
                });
            } else
                if (key === "code" || key === "name") {
                    currentData.sort(function (b, a) {
                        if (a.journey[key] > b.journey[key]) {
                            return -1;
                        }
                        if (b.journey[key] > a.journey[key]) {
                            return 1;
                        }
                        return 0;
                    });
                } else {
                    currentData.sort(function (b, a) {
                        if (a[key] > b[key]) {
                            return -1;
                        }
                        if (b[key] > a[key]) {
                            return 1;
                        }
                        return 0;
                    });
                }
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            if (key === "created") {
                currentData.sort(function (a, b) {
                    if (a[key].firstname + a[key].lastname > b[key].firstname + b[key].lastname) {
                        return -1;
                    }
                    if (b[key].firstname + b[key].lastname > a[key].firstname + a[key].lastname) {
                        return 1;
                    }
                    return 0;
                });
            } else if (key === "code" || key === "name") {
                currentData.sort(function (a, b) {
                    if (a.journey[key] > b.journey[key]) {
                        return -1;
                    }
                    if (b.journey[key] > a.journey[key]) {
                        return 1;
                    }
                    return 0;
                });
            } else {
                currentData.sort(function (a, b) {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                    return 0;
                });
            }
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));

    return (
        <Box style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Helmet>
                <title>History | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/launch-form')}>Launch Form</span> / <span style={styles.end} >History</span></Typography>
                    </Grid>
                    <Grid container item >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px">
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                History
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Box sx={{ width: "100%" }}>
                                <Box pb="30px" pt="30px" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                    <TextField
                                        id="input-with-icon-textfield"
                                        fullWidth
                                        placeholder={t('admin.label.search')}
                                        size="small"
                                        sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                                        className="searchTextField-h40"
                                        value={searchProgress}
                                        onChange={handleSearchProgress}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search style={{ color: "#C4C4C4" }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                            </Box>
                            <div className={classes.root}>
                                <Paper className={classes.flexPaper} >
                                    <Box
                                        px="40px"
                                    >
                                        <Box
                                            px="25px"
                                            py="19px"
                                            sx={{ display: "flex", "flex-direction": "row" }}
                                        >
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(43.38% - 12.5px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    Name
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(9.31% - 12.5px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    Total
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("total", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("total", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(10.92% - 12.5px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    Success
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("success", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("success", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(9.31% - 12.5px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    Fail
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("fail", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("fail", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(12.54% - 12.5px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    Launched By
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("created", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("created", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", justifyContent: "center", width: "calc(14.54% - 12.5px)" }} pr="15px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    Status
                                                </Typography>
                                                <Stack direction="row" spacing={2}>
                                                    <div>
                                                        <FilterStatus
                                                            ref={anchorRef}
                                                            id="composition-button"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={handleToggle}
                                                        />
                                                        <Popper
                                                            open={open}
                                                            anchorEl={anchorRef.current}
                                                            role={undefined}
                                                            placement="bottom-start"
                                                            transition
                                                            disablePortal
                                                            style={{ "z-index": "2" }}
                                                        >
                                                            {({ TransitionProps, placement }) => (
                                                                <Grow
                                                                    {...TransitionProps}
                                                                    style={{
                                                                        transformOrigin:
                                                                            placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                                    }}
                                                                >
                                                                    <Paper sx={{ "margin-top": "5px !important" }}>
                                                                        <ClickAwayListener onClickAway={handleClose}>
                                                                            <MenuList
                                                                                autoFocusItem={open}
                                                                                id="composition-menu"
                                                                                aria-labelledby="composition-button"
                                                                                onKeyDown={handleListKeyDown}
                                                                            >

                                                                                <Box px="16px" py="6px">
                                                                                    <FormGroup>
                                                                                        <FormControlLabel control={<Checkbox indeterminate={success === true || fail === true || pending === true ? success === false || fail === false || pending === false : false} onChange={e => EditNotActive("selectAll")} checked={success === true && fail === true && pending === true} />} label={t('competency.selectAll')} />
                                                                                        <FormControlLabel control={<Checkbox onChange={e => EditNotActive("success")} checked={success} />} label="Success" />
                                                                                        <FormControlLabel control={<Checkbox onChange={e => EditNotActive("fail")} checked={fail} />} label="Fail" />
                                                                                        <FormControlLabel control={<Checkbox onChange={e => EditNotActive("pending")} checked={pending} />} label="In Progress" />
                                                                                    </FormGroup>
                                                                                </Box>
                                                                            </MenuList>
                                                                        </ClickAwayListener>
                                                                    </Paper>
                                                                </Grow>
                                                            )}
                                                        </Popper>
                                                    </div>
                                                </Stack>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "75px" }}>
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ textAlign: "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                    {t('admin.label.action')}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Divider width="100%" />
                                    </Box>
                                    {currentData !== undefined && currentData !== null && currentData.length > 0 ? currentData.map((row, index) => (
                                        <Box px="40px">
                                            <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                                <Box
                                                    sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                                    px="25px"
                                                >
                                                    <Box sx={{ width: "calc(43.38% - 12.5px)" }} pr="15px">
                                                        <Typography fontSize={18} lineHeight="26.91px" fontWeight="500" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.journey?.name}
                                                        </Typography>
                                                        <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.journey?.code}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ width: "calc(9.31% - 12.5px)" }} pr="15px">
                                                        <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {(row?.status === "schedule" && row?.target_type === 'target_group') ? '-' : row?.total}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ width: "calc(10.92% - 12.5px)" }} pr="15px">
                                                        <Typography fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {row?.success}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ width: "calc(9.31% - 12.5px)" }} pr="15px">
                                                        <Typography color="#CC6058" fontSize={16} lineHeight="23.96px" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {isNaN(Number(Util.formatData(row?.fail, 0))) !== true ? Number(Util.formatData(row?.fail, 0)) !== 0 ? row?.fail : "" : ""}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(12.54% - 12.5px)" }} pr="15px">
                                                        <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {Util.formatData(row?.created?.firstname, false) !== false || Util.formatData(row?.created?.lastname, false) !== false ? "" : Util.formatData(row?.date, false) !== false ? "Default" : ""}
                                                            {row?.created?.firstname} {row?.created?.lastname}
                                                        </Typography>
                                                        <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                            {Util.formatData(row?.date, false) !== false ? Util.dateDayTimeFormatAdmin(row?.date) : null}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ width: "calc(14.54% - 12.5px)" }} pr="15px" display="flex" justifyContent="center">
                                                        {row?.status === "finish" ?
                                                            <Box sx={{ background: "rgba(93, 161, 150, 0.1)", width: "100%", maxWidth: "max-content", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                                <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#5DA196", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                    Completed
                                                                </Typography>
                                                            </Box>
                                                            : row?.status === "fail" ?
                                                                <Box sx={{ background: "rgba(204, 96, 88, 0.1)", width: "100%", maxWidth: "max-content", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                                    <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#CC6058", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                        Fail
                                                                    </Typography>
                                                                </Box>
                                                                : row?.status === "pending" ?
                                                                    <Box sx={{ background: "rgba(239, 183, 109, 0.1)", width: "100%", maxWidth: "max-content", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                                        <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#EFB76D", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                            In Progress
                                                                        </Typography>
                                                                    </Box>
                                                                    : row?.status === "schedule" ?
                                                                        <Box sx={{ background: "rgba(239, 183, 109, 0.1)", width: "100%", maxWidth: "max-content", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                                            <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#EFB76D", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                                Schedule
                                                                            </Typography>
                                                                        </Box>
                                                                        :
                                                                        null
                                                        }
                                                    </Box>
                                                    <Box sx={{ display: "flex", flexDirection: "row", width: "75px", justifyContent: "flex-end" }}>
                                                        <Box sx={{ display: "flex", flexDirection: "row", width: "100px", zIndex: "1", justifyContent: "center" }}>

                                                            {row?.status === "schedule" &&
                                                                <StopButton id={row?.schedule?.id} status={row?.schedule?.status} onSuccess={getListData} />
                                                            }

                                                            {((row?.status === "schedule" && row?.target_type === 'specify_employee') || row?.status !== "schedule") &&
                                                                <BootstrapTooltip title={`View Result`} placement="top" onClick={() => openView(row?.id)}>
                                                                    <ViewResult style={{ marginRight: "10px", cursor: "pointer" }} />
                                                                </BootstrapTooltip>
                                                            }

                                                            <BootstrapTooltip title={`Journey Summary`} placement="top" onClick={() => openLaunch(row?.id)}>
                                                                <JourneySummary style={{ cursor: "pointer" }} />
                                                            </BootstrapTooltip>
                                                        </Box>

                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Divider width="100%" />
                                        </Box>
                                    ))
                                        :
                                        <Box sx={{ "padding-top": "50px", "text-align": "center", "padding-bottom": "500px" }}>
                                            <Nodata />
                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                {t('label.noData')}
                                            </Typography>
                                        </Box>
                                    }
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container mt={1} spacing={2} >
                        <Grid item xs sm md display="flex" alignItems="center">
                            <Box mr={1}>
                                <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                            </Box>
                            <Select
                                id="pagination"
                                variant="outlined"
                                defaultValue={10}
                                value={perPage}
                                onChange={handlePerPageChange}
                                displayEmpty
                                size="small"
                                className="white-bg"
                            >
                                <MenuItem value={10}>
                                    <Typography style={{ fontWeight: "300" }}>10</Typography>
                                </MenuItem>
                                <MenuItem value={20}>
                                    <Typography style={{ fontWeight: "300" }}>20</Typography>
                                </MenuItem>
                                <MenuItem value={30}>
                                    <Typography style={{ fontWeight: "300" }}>30</Typography>
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item display="flex" alignItems="center" ml="auto">
                            <Typography variant="s14_fw400">
                                {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                            </Typography>
                        </Grid>
                        <Grid item ml="auto" display="flex" alignItems="center">
                            <CustomPagination
                                setCurrentPage={handleSetCurrentPage}
                                selected={currentPage}
                                count={totalPage}
                            ></CustomPagination>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <DialogViewResult opens={openViewResult} close={closeViewResult} selectViewResult={selectViewResult} />
            <DialogLaunchForm open={openLaunchForm} close={closeLaunchForm} selectLaunchForm={selectLaunchForm} />
        </Box>
    );
};
export default History;
